import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in from localStorage
    const savedUser = localStorage.getItem('geeth365_user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('geeth365_user', JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('geeth365_user');
  };

  const signup = (userData) => {
    // In real app, this would call API
    const newUser = {
      ...userData,
      id: Date.now(),
      subscriptionActive: true,
      createdAt: new Date().toISOString()
    };
    setUser(newUser);
    localStorage.setItem('geeth365_user', JSON.stringify(newUser));
    return newUser;
  };

  const isAuthenticated = !!user;

  const value = {
    user,
    login,
    logout,
    signup,
    isAuthenticated,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export default AuthContext;